export default __webpack_public_path__ + "static/media/profile-active.003aefd4.svg";